import { render, staticRenderFns } from "./decision_log_item.vue?vue&type=template&id=0a892149"
import script from "./decision_log_item.vue?vue&type=script&lang=js"
export * from "./decision_log_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports